module.exports = __webpack_public_path__ + "img/company_cert_bg.db54acbd.png";